import React, { useState, useEffect, useContext } from "react";
import "./Lines.scss";
import green from "../../assets/lines/green_bluesml.gif";
import greendots from "../../assets/lines/zielone2.gif";
import bluedots from "../../assets/lines/bluedots.gif";
import orangedots from "../../assets/lines/dotsorange1.gif";

import orange from "../../assets/lines/orange_pinksml.gif"

import { BuildingsContext } from "../../bContext";

function Lines() {
  const [czas, setczas] = useState(false);
  const [czasOsad, setczasOsad] = useState(false);

  const {wlacz, setwlacz, wlaczOsad, setwlaczOsad} = useContext(
    BuildingsContext
  );

  useEffect(() => {
    if (wlacz){
      setczas(false)
      const timer = setTimeout(() => {
        setczas(true);
      }, 20000);
      return () => clearTimeout(timer);
    }
  
  }, [wlacz]);

  useEffect(() => {
    if (wlaczOsad){
      setczasOsad(false)
      const timer = setTimeout(() => {
        setczasOsad(true);
      }, 10000);
      return () => clearTimeout(timer);
    }
  
  }, [wlaczOsad]);

  return (
    <>
   {wlacz && (
        <div>
        <img className="greenline" src={green} alt="" />
        {czas && (
          <>
            {/* <img className="greenline_dots" src={greendots} alt="" /> */}
            <img className="bluenline_dots" src={bluedots} alt="" />
   
          
          </>
        )}
       
      </div>
   )}
   <div>
     {wlaczOsad && (
       <div>
        <img className="orangeline" src={orange} alt="" />
      
         {czasOsad && (<>
          <img className="orangeline_dots" src={ orangedots} alt="" />
         </> )} 
       </div>
     )}
  
   </div>
    {/* <button onClick={() => setwlacz(!wlacz)} style={{position: "absolute" , width: "10em", height: "10em", backgroundColor: "black"}}>saddddddddddddddd</button> */}
    </>
  );
}

export default Lines;
